export const infracaoMotoristaFilterConfig = [
  {
    id: 'CpfMotorista',
    type: 'text',
    label: 'CPF Motorista',
    placeholder: 'Digite o CPF do motorista'
  },
  {
    id: 'MesFechamento',
    type: 'number',
    label: 'Mes Fechamento',
    placeholder: '1-12'
  },
  {
    id: 'AnoFechamento',
    type: 'number',
    label: 'Ano Fechamento',
    placeholder: 'Ex: 2026'
  },
  {
    id: 'IdInfracao',
    type: 'number',
    label: 'Codigo Infracao',
    placeholder: 'Id da infracao'
  }
];
